<template>
  <div class="assets" @scroll="handleScroll">
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang168') }}</span>
    </div>

    <div class="pd">
      <div class="">
        <div class="bare" v-if="total <= 0">
          <span>{{ $t('lang60') }}</span>
        </div>
        <div v-else class="container">
          <div class="list">
            <div v-for="(item, index) in list" :key="index" class="li">
              <div class="box">
                <div class="box_item">
                  <div class="f-c">
                    <span class="amount">{{ item.amount }}</span>

                    <div>
                      <span style="width: fit-content" :class="item.status == 400 ? 'tag fail' : 'tag'">{{ statusFn(item.status) }}</span>
                      <!-- <span :class="item.status == 400 ? 'tag fail' : 'tag'">{{ statusFn(item.status) }}</span> -->
                    </div>
                  </div>
                  <!-- <span class="key">{{ item.note }}</span> -->
                  <div class="f-c">
                    <span class="num">{{ item.create_time_text }}</span>
                    <span class="num f">
                      {{ $t('lang85') }}：
                      <svg width="11" height="20" viewBox="38 0 50 96" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M70,35
           C56,28 38,40 40,54
           C40,64 50,74 70,66"
                          fill="none"
                          stroke="#aaaaaa"
                          stroke-width="6"
                          stroke-linecap="round"
                        />
                        <line x1="52" y1="29" x2="52" y2="73" stroke="#aaaaaa" stroke-width="5.2" stroke-linecap="round" />
                        <line x1="63" y1="29" x2="63" y2="73" stroke="#aaaaaa" stroke-width="5.2" stroke-linecap="round" />
                      </svg>
                      {{ item.cha_bao }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { homeApi } from '@/api/index';
import { dateFormat } from '@/utils/formatTool.js';
export default {
  data() {
    return {
      page: 1,
      total: 0,
      assets: 0,
      list: [],
    };
  },
  mounted() {
    this.rechargeList();
  },
  methods: {
    //返回上一页
    back() {
      this.$router.back();
    },
    statusFn(status) {
      let result = '';
      switch (status) {
        case 100:
          result = this.$t('lang175');
          break;
        case 200:
          result = this.$t('lang176');
          break;
        case 400:
          result = this.$t('lang177');
          break;
        default:
          break;
      }
      return result;
    },
    navigation(name, query) {
      console.log(query);
      if (query.coin_type == 'server') {
        this.$router.push({ name: 'orders' });
      } else if (query.coin_type == 'btc' || query.coin_type == 'filecoin' || query.coin_type == 'tao') {
        return;
      } else {
        this.$router.push({ name, query });
      }
    },
    changeNav(item, index) {
      this.navIndex = index;
    },
    dateFormatFn(date) {
      return dateFormat(new Date(date * 1000), 'yyyy-MM-dd hh:mm:ss');
    },
    handleScroll(event) {
      const container = event.target;
      const scrollTop = container.scrollTop; // 滚动距离
      const scrollHeight = container.scrollHeight; // 内容总高度
      const clientHeight = container.clientHeight; // 可视区域高度
      // 判断是否滑动到底部
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        console.log('Bottom');
        if (this.page != -1) {
          this.page++; // 页数加 1
          this.rechargeList(); // 触发加载更多
        }
      }
    },
    rechargeList() {
      homeApi.rechargeList({ page: this.page }).then(res => {
        if (res.code == 200) {
          this.total = res.data.total;
          if (this.list.length >= res.data.total) {
            this.page = -1; // 重置为 -1，表示没有更多数据
          } else {
            this.list = [...this.list, ...res.data.rows];
            console.log(this.list.length);
            if (this.list.length >= res.data.total) {
              this.page = -1; // 重置为 -1，表示没有更多数据
            }
          }
        } else {
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.f-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-c {
  display: flex;
  justify-content: space-between;
}
.f-sa {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.f-sb-n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.f-col {
  display: flex;
  flex-direction: column;
}
.f {
  display: flex;
  align-items: center;
}
.assets {
  height: 100vh;
  overflow: auto;
  padding: 80px 0 0;
  // background-color: #fafbfc;
  .top {
    color: #000;
    padding-bottom: 16px;
    margin: 0 6px;
  }
  .navbar {
    position: relative;
    border-radius: 14px;
    color: #000;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    span {
      color: #aaaaaa;
      width: 50%;
      font-size: 14px;
      text-align: center;
      line-height: 50px;
    }
  }

  .total_box {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    font-size: 12px;
    color: #fff;
    height: 180px;
    padding: 30px 0 60px;
    background: linear-gradient(to right, #1ab986, #25d7bb);
    .f-sa {
      width: 100%;
    }
    .total {
      font-size: 28px;
      text-align: center;
      padding: 16px 0 6px;
      color: rgba(#fff, 1);
    }
    .text {
      font-size: 16px;
      font-weight: bold;
      color: rgba(#fff, 1);
    }
    .item {
      color: rgba(#fff, 0.8);
      width: 50%;
      text-align: center;
      display: flex;
      flex-direction: column;
    }
    .buy {
      position: absolute;
      right: 14px;
      top: 14px;

      &_btn {
        color: #29b286;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        background-color: #ffffff;
        border: none;
        padding: 0 16px;
        white-space: nowrap;
        border-radius: 30px;
        display: flex;
        align-items: center;
      }
    }
  }

  .bare {
    text-align: center;
    font-size: 14px;
    padding: 60px 14px;
    color: #888;
  }

  .container {
    margin: -30px 14px 0;
    border-radius: 14px;
    background-color: #fff;
    min-height: 700px;
  }
  .list {
    border-radius: 20px;
    padding: 14px 14px 0;
    margin-top: 16px;
    margin: 16px 6px;
    .li {
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      padding: 0 0 14px;

      .box {
        padding-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &_item {
          width: 100%;
          display: flex;
          flex-direction: column;
          border-bottom: 0.5px solid rgba(190, 190, 190, 0.15);
          padding-bottom: 16px;
          .key {
            color: #aaa;
            font-size: 12px;
            margin-top: 12px;
          }
          .num {
            font-size: 12px;
            color: #aaa;
          }
          .amount {
            color: #000;
            font-size: 18px;
            padding-bottom: 10px;
          }
          // .amount::before {
          //   content: '+';
          //   font-size: 16px;
          // }
          .amount::after {
            content: 'USDT';
            font-size: 10px;
            color: #2c2c2c;
          }
          .tag {
            color: #29b286;
            font-size: 12px;
            padding: 2px 10px;
            border-radius: 10px;
            margin-left: 6px;
            background-color: rgba(#29b286, 0.3);
          }
          .fail {
            color: #c42929;
            background-color: rgba(#c42929, 0.3);
          }
        }
      }
    }
  }
}
</style>